import React from 'react';

import { Segment } from 'components';
import RiskProfilePage from '../../../Tools/RiskQuestionnaire/RiskProfilePage';

export default function RiskQuestionnairePage() {
  return (
    <Segment style={{ minHeight: '100%' }}>
      <RiskProfilePage />
    </Segment>
  );
}
